import type { TextSpan, TextualDisplay } from "@ebay/experience-types-ebay";

export const textFromTD = (td?: TextualDisplay) => (td?.textSpans || []).reduce((acc: string, textSpan: TextSpan = {}) => acc + textSpan.text, "");
